module.exports = __webpack_public_path__ + "img/instagramIconColor.c57bee42.png";